import { useState } from "react";
import { Button, Form } from "antd";

// handle Extra Input Fields visibility with custom component
const ShowExtraField = (props) => {
    const [showLayout, setShowLayouot] = useState(false);
    return showLayout || props.show ? props.children : <Form.Item><Button type='link' onClick={() => setShowLayouot(!showLayout)} > + {props.label} </Button></Form.Item>
}

export default ShowExtraField;